import { useEffect, useState, type FC } from 'react';
import { Bell, X } from 'lucide-react';
import { billingApi } from '../../api/billingApi';
import type { Notification } from '../../features/admin/types/notification';

// Panel de notificaciones GLOBALES de plataforma para el usuario/dueño.
// Lee de lealify-base vía billingApi.myNotifications() (el server ya filtra por
// activas / vigentes / targeting / no-descartadas). Descartar = dismissNotification.
const NotificationsPanel: FC = () => {
  const [notifications, setNotifications] = useState<Notification[]>([]);

  useEffect(() => {
    let active = true;
    billingApi.myNotifications()
      .then(list => { if (active) setNotifications(list); })
      .catch(err => console.error('Error al cargar notificaciones:', err));
    return () => { active = false; };
  }, []);

  const handleDismiss = async (id: string) => {
    // Optimista: lo quitamos de la vista de inmediato.
    setNotifications(prev => prev.filter(n => n.id !== id));
    try {
      await billingApi.dismissNotification(id);
    } catch (err) {
      console.error('Error al descartar notificación:', err);
    }
  };

  if (notifications.length === 0) return null;

  return (
    <div className="space-y-3">
      {notifications.map(n => (
        <div
          key={n.id}
          className="relative flex items-start gap-3 rounded-lg border-l-4 border-accent bg-blue-50 dark:bg-accent/10 p-4 shadow-sm animate-fade-in-up"
        >
          <Bell className="h-5 w-5 text-accent flex-shrink-0 mt-0.5" />
          <div className="flex-1 min-w-0">
            <h3 className="text-sm font-semibold text-content">{n.title}</h3>
            <p className="mt-0.5 text-sm text-content-2 whitespace-pre-line">{n.message}</p>
          </div>
          {n.isDismissible && (
            <button
              type="button"
              onClick={() => handleDismiss(n.id)}
              aria-label="Descartar notificación"
              className="flex-shrink-0 text-content-3 hover:text-content transition-colors"
            >
              <X className="h-4 w-4" />
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default NotificationsPanel;
